module.exports = __webpack_public_path__ + "img/old-phone.aff5b735.svg";